import React,{ useRef, useState,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Components/Molecules/Header/Header";
import SideNavBar from "./Components/Molecules/SideNavBar/SideNavBar";
import { menuData } from "./Schemas/menuSchema";
import "./App.css";
import "./common.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard";
import MyProfile from "./Pages/MyProfile/MyProfile";
import { Login, ForgotPassword,SessionTimeout } from "./Pages/Login/Login";
import {CustomerLogin,CustomerForgotPassword} from "./Pages/Login/CustomerLogin"
import WithAuth from "./Components/Organisms/WithAuth/WithAuth";
import CreateAccount from "./Pages/CreateAccount/CreateAccount";
import SetPassword from "./Pages/CreateAccount/SetPassword"
import CustomerSetPassword  from "./Pages/CreateAccount/CustomerSetPassword"
import ToastNotifier from "./Components/Atoms/ToastNotifier/ToastNotifier";
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store,{ persistor } from "../src/ReduxStore/Store"
import SalesmanList from "../src/Pages/SalesmanList"
import AgentsList from "../src/Pages/AgentsList"
import CustomersList from "./Pages/CustomersList"
import EnquiryList from "./Pages/EnquiryList"
import  ApplicationsList from "./Pages/ApplicationsList"
import LoanApplicationForm from "./Pages/loanForm/LoanApplicationForm"
import Enquiry from "./Pages/CreateAccount/Enquiry"
import ServiceConfigurationList from "./Pages/ServiceConfigurationList"
import LeadsList from "./Pages/LeadsList"
import MysubscriptionList from "./Pages/MysubscriptionList"
import {SubScriptionForm} from "./Pages/SubScriptionForm" 
import SubscribersList from "./Pages/SubscribersList"
import PaymentWithTermsAndConditions  from "./Pages/Payment";
import PaymentFailure from "./Pages/PaymentFailure"
import PaymentSuccess from "./Pages/PaymentSuccess";
import { useLocation } from 'react-router-dom';
import SubscriptionPlans from "./Pages/SubscriptionPlans"
import SupportTicketsList from "./Pages/SupportTicketsList"

function App() {
  return (
    <div className="app-container">
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
      <ToastContainer/>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/customer-login" element={<CustomerLogin />} />
          <Route path="/session-timeout" element={<SessionTimeout />} />
          
          <Route path="/forgot-password" element={<ForgotPassword customer={0} />} />
          <Route path="/customer-forgot-password" element={<CustomerForgotPassword customer={1} />} />
          <Route path="/create-user-account" element={<CreateAccount />} />
          <Route path="/set-password" element={<SetPassword/>} />
          <Route path="/set-customer-password" element={<CustomerSetPassword/>} />
          <Route path="/enquiry" element={<Enquiry/>} />
          <Route path="/subscribe-plan" element={<SubScriptionForm/>}/>
          <Route path="/payment" element={<PaymentWithTermsAndConditions/>}/>
          <Route path="/payment-failure" element={<PaymentFailure/>}/>
          <Route path="/payment-success" element={<PaymentSuccess/>}/>
          <Route path="/subscription-plans" element={<SubscriptionPlans/>}/>
          
          
          
          
          {/* Protected routes are rendered inside the ProtectedLayout */}
          <Route path="/*" element={<ProtectedLayout />} />
          
        </Routes>
      </Router>
      </PersistGate>
      </Provider>

    </div>
  );
}

// ProtectedLayout to render sidebar and header on protected routes
// ProtectedLayout to render sidebar and header on protected routes
const ProtectedLayout = () => {
  const location = useLocation(); // Get the current location
  const childRef = useRef();
  const [togle_mobile_menu_cls,set_togle_mobile_menu] = useState("");
  const role_id = localStorage.getItem("role_id");
  const handleClick = () => {
    
    if(togle_mobile_menu_cls=="sidebaropen"){
      
      set_togle_mobile_menu("")
    }else{
      
      set_togle_mobile_menu("sidebaropen")
    }

    
  };
  
  useEffect(() => {
    set_togle_mobile_menu("") 
  }, [location]); // Dependency array ensures this effect runs on location changes

  return (
    <div className="d-flex">
      <div className= {`sidebar col-auto p-0 ${togle_mobile_menu_cls}`}>
        <SideNavBar menuItems={menuData} ref={childRef} />
      </div>

      <div className="flex-fill containermain" >
        <Header toggleSidebar={handleClick} />
        <div className="main-content" onClick={()=>set_togle_mobile_menu("")} >
          <Routes>
            <Route path="/" element={<Navigate to={role_id == 1 ? "/customer-login" : "/login"} />} />
            <Route  path="/dashboard" element={<Dashboard />}  />
            <Route path="/my_profile"  element={<MyProfile/>}  />
            <Route path="/salesman-list"  element={<SalesmanList/>}  />
            <Route path="/manage_agents"  element={<AgentsList/>}  />
            <Route path="/subscribers" element={<SubscribersList/>} />
            <Route path="/manage_customers" element={<CustomersList/>} />
            <Route path="/enquires" element={<EnquiryList/>} />
            <Route path="/leads"  element={<LeadsList/>}  />
            <Route path="/loan-applications"  element={<LeadsList/>}  />
            <Route path="/my-subscriptions"  element={<MysubscriptionList/>}  />
            
            
            <Route path="/loan-application-form" element={<LoanApplicationForm/>}/>
            {/*<Route path="/loan-application-form/:loanApplicationId" element={<LoanApplicationForm/>}/> */}
            <Route path="/data_entry" element={<ApplicationsList/>}/>

            {
              <Route path="/service_configuration" element={<ServiceConfigurationList/>}/>
              
            }
             <Route path="/subscribe" element={<SubScriptionForm/>}/>

             <Route path="/support-tickets" element={<SupportTicketsList/>}/>
             
            
            {/* Optional 404 route */}
            {/* <Route path="*" element={<NotFound />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default App;
